// Fakturaliste (en).
window.PlummeI18n.register('en', {
  // ------------------------------------------------------------ Invoice list
  'inv.title': 'Invoices',
  'inv.titleHelp': 'An overview of invoices, quotes, order confirmations and credit notes for the selected financial year.',
  'inv.searchPh': 'Search by invoice number, customer or amount',
  'inv.searchHelp': 'Search by invoice number, customer name, invoice amount, net amount, paid amount or remaining amount.',
  'inv.rows.searchHelp': 'Search by the start of an invoice number or customer name. Use id: followed by the exact document ID for a direct lookup. The selected period and filters still apply.',
  'inv.rows.searchPh': 'Invoice number, customer or id:document-ID',
  'inv.downloadHelp': 'Download the list for the tab and filter you have selected.',
  'inv.addHelp': 'Create a new invoice.',
  'inv.add': 'New invoice',
  'inv.filterHelp': 'Filter the list by status, document type, date, period, amount and archive.',
  'inv.tabsHelpTitle': 'Document types',
  'inv.tabsHelp': 'Switch between Invoice, Draft, Quote/Order confirmation, Credit note and Sales report.',
  'inv.listHelpTitle': 'The invoice list',
  'inv.listHelp': 'Each row is one document from the backend. Tap a row for details and actions.',
  'inv.loading': 'Loading invoices',
  'inv.loadingSub': 'Fetching data from the backend.',
  'inv.noMatch': 'No matches here',
  'inv.noMatchSub': 'Try another tab or clear the filter.',
  'inv.rows.showing': 'Showing {shown} of {total}',
  'inv.rows.shown': 'Showing {shown}',
  'inv.rows.pageOf': 'This page: {shown} of {total} matches',
  'inv.rows.pageShown': 'This page: {shown} matches',
  'inv.rows.pageScope': 'Sorting, selection and list export apply to this page. Filters may leave pages empty; use Next or Previous to continue.',
  'inv.rows.pageFileSuffix': '-current-page',
  'inv.rows.previous': 'Previous',
  'inv.rows.next': 'Next',
  'inv.rows.first': 'Refresh from start',
  'inv.rows.retry': 'Retry',
  'inv.rows.pageError': 'Could not load this page. Retry or refresh from the start.',
  'inv.rows.loadMore': 'Load more',
  'inv.rows.loadingMore': 'Loading…',
  'inv.backToVouchers': 'Back to transactions',

  'inv.type.invoice': 'Invoice',
  'inv.type.quote': 'Quote',
  'inv.type.orderConfirmation': 'Order confirmation',
  'inv.type.creditNote': 'Credit note',
  'inv.type.unknown': 'Document',
  'inv.tab.salesReport': 'Sales report',
  'inv.importHistory.tab': 'Imported history',
  'inv.importHistory.loading': 'Loading imported invoice history …',
  'inv.importHistory.error': 'Could not load imported invoice history.',
  'inv.importHistory.readOnly': 'This is read-only history from the previous system. It does not affect bookkeeping or VAT and has no invoice actions in Plumme.',
  'inv.importHistory.documents': 'Documents',
  'inv.importHistory.year': 'Imported history for {year}',
  'inv.importHistory.netSales': 'Net sales',
  'inv.importHistory.customers': 'Customers',
  'inv.importHistory.creditNotes': 'Credit notes',
  'inv.importHistory.netIncluded': 'Deducted from net sales',
  'inv.importHistory.search': 'Search by invoice number or customer',
  'inv.importHistory.empty': 'No imported invoice details for this year',
  'inv.importHistory.emptySub': 'Imported accounting totals are still used in reports and advice when available.',
  'inv.importHistory.detailTitle': 'Details from the import file',
  'inv.importHistory.dueDate': 'Due date',
  'inv.importHistory.paidDate': 'Paid date',
  'inv.importHistory.remaining': 'Outstanding',
  'inv.importHistory.lines': 'Imported lines',
  'inv.importHistory.noLines': 'The source system only supplied invoice totals for this document.',
  'inv.importHistory.markSettled': 'Mark as settled',
  'inv.importHistory.reopenStatus': 'Reopen status',
  'inv.importHistory.manualSettledNote': 'Marked as settled in Plumme without bookkeeping.',
  'inv.importHistory.settledToast': 'The imported invoice is marked as settled.',
  'inv.importHistory.reopenedToast': 'The imported invoice was reopened.',
  'inv.importHistory.statusError': 'Could not update the imported invoice.',
  'inv.importHistory.sourceNote': 'Imported from the previous system – the document is stored in the import file.',
  'inv.importHistory.creditReference': 'Imported credit note from the previous system – credits invoice {number}.',
  'inv.importHistory.creditedReference': 'Imported from the previous system · credited by credit note {number}',
  'inv.importHistory.reanalysisTitle': 'Imported invoice history must be analyzed again',
  'inv.importHistory.reanalysisBody': 'The saved analysis predates credit notes being read from separate credit-note sheets. The source data will not be changed.',
  'inv.importHistory.reanalysisAction': 'Go to reanalysis',
  'inv.importHistory.rowSource': 'Imported from previous system',
  'adv.sales.importedHistoryNote': 'The analysis combines posted Plumme invoices with read-only sales history from the import. Credit notes are deducted. {coverage}',
  'adv.sales.importedTotalsCoverage': 'The import contains invoice totals, but not product lines for every document.',
  'adv.sales.importedLinesCoverage': 'The import also contains invoice lines for parts of the history.',
  'inv.tab.drafts': 'Drafts',
  'inv.filterDocType': 'Document type',
  'inv.filterArchive': 'Archive',
  'inv.filterSeeArchived': 'Show archived',

  'inv.status.draft': 'Draft',
  'inv.status.created': 'Not sent',
  'inv.status.sent': 'Sent',
  'inv.status.accepted': 'Accepted',
  'inv.status.confirmed': 'Confirmed',
  'inv.status.paid': 'Paid',
  'inv.status.unpaid': 'Unpaid',
  'inv.status.overdue': 'Overdue',
  'inv.status.credited': 'Credited',

  'inv.kpi.invoiceCount': 'Invoices',
  'inv.kpi.invoiceCount.help': 'The number of invoices you have created in the selected year, whatever their status.',
  'inv.kpi.revenue': 'Revenue',
  'inv.kpi.revenue.help': 'The total of all invoices excluding VAT for the year.',
  'inv.kpi.notSent': 'Not sent',
  'inv.kpi.notSent.help': 'Invoices sitting as drafts, waiting to be sent.',
  'inv.kpi.credited': 'Credited',
  'inv.kpi.credited.help': 'The number of credit notes.',
  'inv.kpi.quotes': 'Quotes',
  'inv.kpi.quotes.help': 'The number of quotes for the year.',
  'inv.kpi.accepted': 'Accepted',
  'inv.kpi.accepted.help': 'The number of quotes the customer has accepted.',
  'inv.kpi.orders': 'Order confirmations',
  'inv.kpi.orders.help': 'The number of order confirmations for the year.',
  'inv.kpi.creditNotes': 'Credit notes',
  'inv.kpi.creditNotes.help': 'The number of credit notes for the year.',
  'inv.kpi.value': 'Value',
  'inv.kpi.value.help': 'The total value excluding VAT of the documents in this tab.',
  'inv.kpi.amount': 'Amount',
  'inv.kpi.amount.help': 'The total amount excluding VAT for the credit notes.',
  'inv.kpi.sent': 'Sent',
  'inv.kpi.sent.help': 'The number of documents sent to the customer.',
  'inv.kpi.confirmed': 'Confirmed',
  'inv.kpi.confirmed.help': 'Order confirmations the customer has confirmed.',
  'inv.kpi.drafts': 'Drafts',
  'inv.kpi.drafts.help': 'Documents that have not been sent yet.',
  'inv.kpi.potentialRevenue': 'Potential revenue',
  'inv.kpi.potentialRevenue.help': 'The total value of drafts that could still be sent.',
  'inv.kpi.customers': 'Customers',
  'inv.kpi.customers.help': 'The number of unique customers on the drafts.',
  'inv.kpi.history': 'Age',
  'inv.kpi.history.help': 'How long the oldest draft has been waiting.',
  'inv.kpi.sub.totalYear': 'Total this year',
  'inv.kpi.sub.exVat': 'Excl. VAT',
  'inv.kpi.sub.waiting': 'Waiting for you',
  'inv.kpi.sub.creditNotes': 'Credit notes',
  'inv.kpi.sub.started': 'Documents started',
  'inv.kpi.sub.uniqueCustomers': 'Unique customers',
  'inv.kpi.sub.oldestDraft': 'Oldest draft',
  'inv.kpi.sub.noDrafts': 'No drafts',
  'inv.kpi.sub.none': 'None',
  'inv.kpi.sub.days': '{n} days',
  'inv.kpi.sub.sentQuotes': 'Quotes sent',
  'inv.kpi.sub.accepted': 'Accepted',
  'inv.kpi.sub.confirmed': 'Confirmed',
  'inv.kpi.sub.notSent': 'Not sent',
  'inv.kpi.sub.sent': 'Sent',

  'inv.col.document': 'Document',
  'inv.col.invoice': 'Invoice',
  'inv.col.date': 'Date',
  'inv.col.net': 'Net',
  'inv.col.amount': 'Amount',
  'inv.col.status': 'Status',
  'inv.col.number': 'No.',
  'inv.col.customer': 'Customer',
  'inv.netInline': 'Net {amount}',
  'inv.draftPlaceholder': 'DRAFT',

  'inv.detail.dueTitle': 'Due date',
  'inv.detail.dueHelp': 'The date the document applies until, or is to be paid by.',
  'inv.detail.statusHelp': 'Payments come from posted PaymentEntry records. Quotes and order confirmations show completion status.',
});
